const SessionManager = async ({ baseURL, container }) => {
	const url = `${baseURL}/session`;

	const iframe = document.createElement("iframe");
	iframe.src = url;
	iframe.style.display = "none";

	const _getPostMessage = (event, resolve) => {
		if (typeof event.data === "object" && event.data.isSessionManager) {
			const receivedPayloadData = event.data?.payload;
			resolve(receivedPayloadData);
		}
	};

	const getSession = async (key, fallbackKey) => {
		const data = await new Promise(resolve => {
			window.addEventListener("message", event =>
				_getPostMessage(event, resolve)
			);

			iframe.contentWindow.postMessage(
				{
					isSessionManager: true,
					payload: {
						type: "getSession",
						key
					}
				},
				"*"
			);
		});

		window.removeEventListener("message", _getPostMessage);

		if (!data) {
			// If no data from iframe (could be blocked), use the hosting application's localStorage
			try {
				const currentSessionData = JSON.parse(
					localStorage.getItem("session-manager")
				);

				if (currentSessionData) {
					if (key) {
						return currentSessionData[key] ?? null;
					}
					return currentSessionData;
				}

				return JSON.parse(localStorage.getItem(fallbackKey));
			} catch (err) {
				return null;
			}
		}

		return data;
	};

	const setSession = async payload => {
		const currentSessionData = await getSession();
		const newSessionData = { ...currentSessionData, ...payload };

		const data = await new Promise(resolve => {
			window.addEventListener("message", event =>
				_getPostMessage(event, resolve)
			);

			iframe.contentWindow.postMessage(
				{
					isSessionManager: true,
					payload: {
						type: "setSession",
						data: newSessionData
					}
				},
				"*"
			);
		});

		window.removeEventListener("message", _getPostMessage);

		if (!data) {
			localStorage.setItem("session-manager", JSON.stringify(newSessionData));
		}

		return data;
	};

	return new Promise(resolve => {
		iframe.onload = () => {
			resolve({
				getSession,
				setSession
			});
		};
		container.appendChild(iframe);
	});
};

export default SessionManager;
export { SessionManager };
